import { Pipe, PipeTransform } from '@angular/core';
import { modulo } from '../utils';


@Pipe({
    name: 'chunk',
})
export class ChunkPipe implements PipeTransform {

    transform(value: any, size = 1): any {
        if (!Array.isArray(value)) {
            return value;
        }
        return value.reduce((prev, cur, index) => modulo(index, size) ? prev : prev.concat([value.slice(index, index + size)]), []);
    }
}
